/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type TraceMessage = {
  role: string;
  content: string;
};

export type SpanInfo = {
  start: number;
  end: number;
};

export type EvidenceItem = {
  message_index: number;
  type: string;
  text: string;
  span: SpanInfo;
};

export type EvidenceStatus = "READY" | "ANALYSIS_REQUIRED" | "UNAVAILABLE";

export type TraceViolationItem = {
  violated_type: string;
  violated_policy_name: string;
  violated_rules_list: string[];
  rationale: string;
  metadata: Record<string, unknown>[];
  evidence_status?: EvidenceStatus;
  evidence?: EvidenceItem[];
};

export type TraceDetailType = {
  service_token_id: string;
  trace_id: string;
  route: string;
  status_code: number;
  error_code: string;
  scanned_messages: TraceMessage[];
  scan_type: string;
  latency_ms: number;
  scan_policy: string[];
  violated_types: string[];
  timestamp: string;
  scan_result: {
    decision: string;
    reasons: TraceViolationItem[];
  };
};

export type TraceDetailRequestType = {
  traceId: string;
  token: string;
};

export default function getTraceDetail({ traceId, token }: TraceDetailRequestType): Promise<InternalResponse> {
  return request()({
    url: `/xecguard/v1/trace/${traceId}`,
    method: "GET",
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<TraceDetailType>): InternalResponse<TraceDetailType> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
